export default __webpack_public_path__ + "Quicken_Logo_animated_dark.gif";